export default {"src":"/_next/static/media/solar_blank.afabff3e.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};